import config from 'crm/config'

const customerApi = `${config.apiHost}/oem-customer`

export default {
    statByDate: {
        url: `${customerApi}/api/customer_chat_stat/by_date`,
        type: 'GET',
    },
    exportStatByDate: {
        url: `${customerApi}/api/customer_chat_stat/by_date.xlsx`,
        type: 'GET',
    },
}
